<template>
    <div class="">
        <div class="w-full flex justify-center">
            <div class="w-[460px]">
                <ElementsDateSearchPackLite
                v-model:startDate="searchRequest.startSearchDate" 
                v-model:endDate="searchRequest.endSearchDate"
                @searchEvent="searchSelectedDate" 
                />
            </div>
        </div>
        <!-- EXCEL DOWNLOAD BUTTON______________________________________________________________________________________________________________ -->
        <div class="mt-9 flex justify-end">
            <ElementsPopupDownloadExcel
                popupTitle="Download Usage History"
                :departmentOptions="departmentOptions" :jobTitleOptions="jobTitleOptions" :employeeList="popupListEmployees"
                @download-excel="downLoadUsageHistory"
                :selectedOneEmployee="selectedOneEmployee"
            />
        </div>
        <!-- SEARCH ______________________________________________________________________________________________________________ -->
        <div class="flex justify-between items-center flex-wrap mt-3">
            <div class="flex justify-between items-center gap-2">
                <DesignMultiSelectFilter
                    v-model="employeeSearchForm.employeeStatusList"
                    :options="statusOptions"
                    label="Status"
                    modalTitle="Select Status"
                    size="LG"
                    :width="'w-60'"
                    @change="searchFlexbenEmployee()"
                />

                <DesignDropdownSelect 
                    @change="searchFlexbenEmployee()"
                    v-model="employeeSearchForm.departmentSeq" 
                    :options="departmentOptions"
                    size="LG"
                    :width="'w-60'"
                    placeholder="All Departments" 
                    :useDefaultMsg="true"/>

                <DesignDropdownSelect 
                    @change="searchFlexbenEmployee()"
                    v-model="employeeSearchForm.jobTitleSeq" 
                    :options="jobTitleOptions"
                    size="LG"
                    :width="'w-60'"
                    placeholder="All Tiers" 
                    :useDefaultMsg="true" />
                
                <ElementsSearchBar @searchEvent="searchFlexbenEmployee()"
                    v-model="employeeNameForSearch"
                    :options="employeeOptions"
                    :height12="true" :width60="true" :placeholder="'Search Employees'" ref="employeeSearchBar"
                    :optionClickEvent="true" :hasSearchButton="true" />
            </div>

            <!--for aboitiz - cost center, business unit-->
            <div v-show="isAboitiz" class="flex w-full border-t border-gray-300 my-4 gap-4 pt-4" >
                <DesignDropdownSelect
                    v-model="selectSearchedValues.schType"
                    :options="selectOptionList"
                    size="LG"
                    :width="'w-[180px]'"
                    :placeholder="selectSearchPlaceholder" 
                    />

                <ElementsSearchBar
                    @searchEvent="searchFlexbenEmployee()"
                    v-model="selectSearchedValues.schKeyword"
                    :height12="true"
                    :width60="true" 
                    :placeholder="textSearchPlaceholder" 
                    ref="employeeSelectSearchBar"
                    :optionClickEvent="true" 
                    :hasSearchButton="true" />
            </div>
        </div>

        <!-- CONTENT ______________________________________________________________________________________________________________ -->
        <div class="mt-5 w-full flex justify-between gap-3">
            <!-- EMPLOYEE ______________________________________________________________________________________________________________ -->
            <div class="rounded bg-white shadow border shadow-gray-200 box-style-border ">
                <div class="flex justify-between items-center">
                    <h3 class="p-5 text-base font-medium text-slate-500">
                        Name
                    </h3>
                </div>

                <div class="w-full h-px bg-gray-200"></div>
                <div class="w-[320px]">
                    <template v-for="(employee, index) in displayEmployeeList" v-bind:key="index">
                        <div
                            class="px-7 py-2 min-w-[320x] w-full border-b border-color-gray-200 hover:bg-slate-200 transition-all duration-500"
                            :class="{ 'bg-slate-200': employee.employeeSeq == selectedOneEmployee?.employeeSeq }"
                            @click="clickEmployee(employee)">
                            <div class="grid grid-cols-10 gap-2 items-center break-words">
                                <StatusCircle :status-code="employee.employeeStatus" class="col-span-1"/>
                                <div class="text-base font-bold col-span-9"> {{ employee.employeeName }} </div>
                                <div class="col-span-1"></div>
                                <div class="col-span-9 text-sm font-normal">{{ employee.departmentName }} </div>
                            </div>
                        </div>
                    </template>
                    <template v-if="displayEmployeeList.length==0">
                        <div class="h-20 px-7 py-2 min-w-[320px] w-full border-b border-color-gray-200 transition-all duration-500"></div>
                        <div class="h-20 bg-slate-200 px-7 py-2 min-w-[320px] w-full border-b border-color-gray-200 transition-all duration-500"></div>
                    </template>
                </div>
                <button v-if="displayEmployeeList.length < searchedEmployeeListAll.length"
                        @click="()=>{ displayEmployeeList = loadEmployeeMore(displayEmployeeList.length); }"
                        class="text-[#6B7280] w-full text-center hover:bg-[#F3F4F6] py-5">
                    View More
                    <img class="inline" src="@/assets/img/down-icon.svg" alt="app-popup-1" />
                </button>
            </div>

            <!-- USAGE LIST  ______________________________________________________________________________________________________________ -->
            <div class="">
                <div class="min-w-[750px] bg-white border border-[#D6DDEB] ">
                    <div class="w-full flex justify-between py-3 px-5 items-center ">
                        <div>
                            <div class="leading-6 font-bold text-xl text-[#2E2C34] my-1">
                                {{ selectedOneEmployee.employeeName }}
                            </div>
                            <div class="leading-6 text-[#6B7280] font-semibold text-sm my-1">
                                {{ [ (selectedOneEmployee.departmentName || '-'), (selectedOneEmployee.jobTitleName || '-')].join(" / ") }} 
                            </div>
                        </div>
                        <div class="py-3 px-7 rounded-lg text-[#6B7280] font-semibold text-sm text-center bg-[#F0F5FF]">
                            <div>Available Points</div>
                            <div>
                                <span v-if="!!selectedOneEmployee.walletEmployeeMileage" class="text-blue-800">{{ fitDecimalFormatWithComma(selectedOneEmployee.walletEmployeeMileage, 0) }}</span> 
                                <span v-else class="text-blue-800">{{ 0 }}</span>P
                            </div>
                        </div>
                    </div>
                    <table class="w-full table-fixed">
                        <thead class="border-t border-b border-[#D6DDEB]">
                            <tr>
                                <th scope="col" class="w-[12%] py-4 text-base font-medium text-slate-500 text-center">Date</th>
                                <th scope="col" class="py-4 text-base font-medium text-slate-500 text-center w-[18%]">Brand</th>
                                <th scope="col" class="py-4 text-base font-medium text-slate-500 text-center w-[18%]">Treat Name</th>
                                <th scope="col" class="w-[12%] py-4 text-base font-medium text-slate-500 text-center">Points</th>
                                <th v-if="walletCategoryCnt>1" scope="col" class="w-[12%] py-4 text-base font-medium text-slate-500 text-center">Wallet</th>
                                <th scope="col" class="w-[12%] py-4 text-base font-medium text-slate-500 text-center">Point<br/> Balance</th>
                                <th v-if="isAboitiz" scope="col" class="w-[12%] py-4 text-base font-medium text-slate-500 text-center">Cost<br/>Center</th>
                                <th v-if="isAboitiz" scope="col" class="w-[12%] py-4 text-base font-medium text-slate-500 text-center">Business<br/>Unit</th>
                                <th scope="col" class="w-[12%] py-4 text-base font-medium text-slate-500 text-center"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="histListEmployee.length === 0">
                                <td :colspan="emptyRowColspan" class="py-16 text-center text-content-basic-3 text-sm">
                                    </td>
                            </tr>
                            <tr v-for="(hist, index) in histListEmployee" v-bind:key="index"
                                class="h-[4rem]" :class="[(index%2==0) ? 'bg-inherit' : 'bg-[#F8F8FD]']">
                                <td class=" text-center text-sm font-normal truncate">
                                    <div> {{ dateFormatter(hist.transactionDate, 'MM/DD/YYYY') }}</div>
                                    <div> {{ dateFormatter(hist.transactionDate, 'HH:mm') }}</div>
                                </td>
                                <td class="text-center text-sm font-normal"><div class="line-clamp-2">{{ hist.brandName }}</div></td>
                                <td class="text-center text-sm font-normal"><div class="line-clamp-2">{{ hist.goodsName }}</div></td>
                                <td class="text-center text-sm font-normal truncate">{{ fitDecimalFormatWithComma(hist.totalAmountVolume, 0) }}</td>
                                <td v-if="walletCategoryCnt>1" class="text-center text-sm font-normal truncate"> {{ hist.walletCategoryName }}</td>
                                <td class="text-center text-sm font-normal truncate">{{ fitDecimalFormatWithComma(hist.afterMileage, 0) }}</td>
                                <td v-if="isAboitiz" class="text-center text-sm font-normal truncate">{{ $validateUtil.emptyValueToDash(hist.costCenterName) }}</td>
                                <td v-if="isAboitiz" class="text-center text-sm font-normal truncate">{{ $validateUtil.emptyValueToDash(hist.businessUnitName) }}</td>
                                <td class="text-center text-sm font-normal">
                                    <button @click="showDetailPopup(hist)"
                                        class="border border-[#1C64F2] text-[#1C64F2] font-medium text-sm items-center rounded-[4px] px-[10px] py-1">
                                        Detail
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div v-if="histListEmployee.length!==0" class="w-full h-28 flex justify-center items-center">
                        <ElementsPagination v-model="currentPage"
                                            :totalContent="totalCount"
                                            :contentsPerPage="searchRequest.limit"
                                            @clickPage="afterClickPage"
                                            :unClickedBg="'bg-inherit hover:bg-gray-100'" />
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- POPUPS ______________________________________________________________________________________________________________ -->
    <Teleport to="body">
        <AppPopup id="detail popup" v-model="showDetailPopupOpen" name="Detail">
            <div class="grid gap-2 my-5 mx-6 p-5 bg-[#F8F8FD] w-[632px]">
                <div class="text-[#418BFF] text-sm font-semibold text-center"> {{ dateFormatter(goodsOrder.transactionDate, "MMM DD, YYYY, ddd (HH:mm:ss)") }}</div>
                <div class="grid grid-cols-3 gap-2">
                    <dt class="col-span-1 text-[#383838] text-sm font-semibold leading-5"> Order ID</dt>
                    <dd class="col-span-2 text-[#767677] text-sm font-medium text-left line-clamp-2"> {{ goodsOrder.bizOrderReferenceNo }} </dd>
                </div>
                <div class="grid grid-cols-3 gap-2">
                    <dt class="col-span-1 text-[#383838] text-sm font-semibold  leading-5"> Brand </dt>
                    <dd class="col-span-2 text-[#767677] text-sm font-medium text-left line-clamp-2"> {{ goodsOrder.brandName }} </dd>
                </div>
                <div class="grid grid-cols-3 gap-2">
                    <dt class="col-span-1 text-[#383838] text-sm font-semibold  leading-5"> Treat </dt>
                    <dd class="col-span-2 text-[#767677] text-sm font-medium text-left line-clamp-2"> {{ goodsOrder.goodsName }} </dd>
                </div>
                <div class="grid grid-cols-3 gap-2">
                    <dt class="col-span-1 text-[#383838] text-sm font-semibold  leading-5"> Points </dt>
                    <dd class="col-span-2 text-[#767677] text-sm font-medium text-left line-clamp-2"> {{ goodsOrder.totalAmountVolume }} </dd>
                </div>
                <div class="grid grid-cols-3 gap-2">
                    <dt class="col-span-1 text-[#383838] text-sm font-semibold  leading-5"> Sender Name </dt>
                    <dd class="col-span-2 text-[#767677] text-sm font-medium text-left line-clamp-2"> {{ goodsOrder.orderSenderName }} </dd>
                </div>
                <div class="grid grid-cols-3 gap-2" v-if="goodsOrder.orderTreatType === 'FRIEND'">
                    <dt class="col-span-1 text-[#383838] text-sm font-semibold  leading-5"> Recipient Name </dt>
                    <dd class="col-span-2 text-[#767677] text-sm font-medium text-left line-clamp-2"> {{ goodsOrder.orderRecipientName }} </dd>
                </div>
                <div class="grid grid-cols-3 gap-2">
                    <dt class="col-span-1 text-[#383838] text-sm font-semibold  leading-5"> Phone Number </dt>
                    <dd class="col-span-2 text-[#767677] text-sm font-medium text-left line-clamp-2"> {{ goodsOrder.orderRecipientPhoneNo }} </dd>
                </div>
                <div class="grid grid-cols-3 gap-2">
                    <dt class="col-span-1 text-[#383838] text-sm font-semibold  leading-5"> Email </dt>
                    <dd class="col-span-2 text-[#767677] text-sm font-medium text-left line-clamp-2"> {{ goodsOrder.orderRecipientEmail }} </dd>
                </div>
                <div class="grid grid-cols-3 gap-2">
                    <dt class="col-span-1 text-[#383838] text-sm font-semibold  leading-5"> Message </dt>
                    <dd class="col-span-2 text-[#767677] text-sm font-medium text-left line-clamp-2"> {{ goodsOrder.orderSenderMessage }} </dd>
                </div>
            </div>
        </AppPopup>
    </Teleport>
</template>

<script>
import ElementsDateSearchPackLite from '@/components/elements/ElementsDateSearchPackLite.vue';
import ElementsPopupDownloadExcel from '@/components/elements/ElementsPopupDownloadExcel.vue';
import ElementsNotification from '@/components/elements/ElementsNotification.vue';
import DesignButton from '@/components/design-system/design-button.vue';
import DesignDropdownSelect from '@/components/design-system/design-dropdown-select.vue';
import DesignMultiSelectFilter from '@/components/design-system/design-multi-select-filter.vue';
import ElementsSearchBar from '@/components/elements/ElementsSearchBar.vue';
import ElementsPagination from '@/components/elements/ElementsPagination.vue';
import StatusCircle from '@/components/employee/status-circle/status-circle';
import AppPopup from '@/components/AppPopup.vue';
import { NumberFormatUtil } from '@/plugins/app-util';
import {getAboitizInfo} from "@/plugins/app-pre-init";
import ElementsSelectSearchBar from "@/components/elements/ElementsSelectSearchBar";
import moment from 'moment-timezone';

export default {
    components : {
        AppPopup,
        DesignButton,
        ElementsNotification,
        ElementsPopupDownloadExcel,
        ElementsSearchBar,
        StatusCircle,
        ElementsPagination,
        ElementsSelectSearchBar,
        ElementsDateSearchPackLite,
        DesignDropdownSelect,
        DesignMultiSelectFilter,
    },
    data(){
        return {
            selectDate: {
                limit: 10,
                offset: 0,
                startSearchDate: null,
                endSearchDate: null,
            },

            walletCategoryCnt : 0,
            // emp list
            employeeSearchForm : {
                // 다중 선택 Status (TimeReports와 동일 옵션)
                employeeStatusList : ['ACTIVE', 'ON_LEAVE', 'EXTENSION_REQUIRED', 'EXTENSION_PAST_DUE', 'CONTRACT_INFO_REQUIRED'],
                departmentSeq : null,
                jobTitleSeq : null,
            },
            // usage hist
            searchRequest: {
                limit: 10,
                offset: 0,
                startSearchDate: null,
                endSearchDate: null,
                employeeSeqList : [],
            },

            statusOptions: [
                { text: 'Active', value: 'ACTIVE' },
                { text: 'Inactive', value: 'ON_LEAVE' },
                { text: 'Extension Required', value: 'EXTENSION_REQUIRED' },
                { text: 'Extension Past Due', value: 'EXTENSION_PAST_DUE' },
                { text: 'Contract Info Required', value: 'CONTRACT_INFO_REQUIRED' },
                { text: 'Resigned', value: 'RESIGNED' },
            ],
            jobTitleOptions : [],
            departmentOptions : [],

            popupListEmployees: [],

            searchedEmployeeListAll : [],
            displayEmployeeList : [],
            employeeLoadCount : 20,
            selectedOneEmployee : {},
            //
            employeeNameForSearch: null,
            employeeOptions: [],

            histListEmployee : [],

            //pagination
            totalCount : 0,
            currentPage : 0,

            // detail popup
            showDetailPopupOpen : false,
            goodsOrder : {},

            // for aboitiz (cost center, business unit) ----------------------------
            aboitizSeq: getAboitizInfo().companySeq,
            companySeq: sessionStorage.getItem("companySeq"),
            isAboitiz: false,
            selectSearchPlaceholder: 'Search Type',
            selectOptionList: [
                {value: ''  , text: 'Search Type' },
                {value: 'COST_CENTER'  , text: 'Cost Center' },
                {value: 'BUSINESS_UNIT', text: 'Business Unit' },
            ],
            textSearchPlaceholder: 'Select search type',
            selectSearchedValues: { schType: '', schKeyword: '' },

            scrollYBackup: 0
        }
    },
    computed: {
        // 여기에 모달이 더 있으면 || 로 추가
        isAnyPopupOpen() {
            return this.showDetailPopupOpen;
        },
        emptyRowColspan() {
            let columns = 6;
            if (this.walletCategoryCnt > 1) {
                columns += 1; 
            }
            if (this.isAboitiz) {
                columns += 2; 
            }
            return columns;
        },
    },
    watch: {
        isAnyPopupOpen(val) {
            if (val) {
                this.lockBodyScroll();
            } else {
                this.unlockBodyScroll();
            }
        },
        'employeeSearchForm.employeeStatusList': {
            deep: true,
            handler() {
                this.getEmployeeOptions();
            }
        }
    },
    beforeMount() {
        this.isAboitiz = this.aboitizSeq == this.companySeq
    },
    async mounted(){
        const self = this;
        self.initWeeklyRange();
        try{
            // 상태 : 초기 화면 목록용 (RESIGNED 제외)
            const empRes = await self.getFlexbenEmployee();
            // init 
            self.popupListEmployees = self.orderByKeyAsc("employeeName", empRes.data.data.list);
            // 상태 : 자동완성용 (RESIGNED 포함)
            await self.getEmployeeOptions();

            // 화면
            self.searchedEmployeeListAll = self.orderByKeyAsc("employeeName", empRes.data.data.list);
            self.displayEmployeeList = self.loadEmployeeMore(0);
            self.clickEmployee(self.displayEmployeeList[0]);
        }catch (error) {
            console.error('Error:', error);
        }

        self.getDepartmentOptions();
        self.getJobTitleOptions();
    },
    methods : {
        initWeeklyRange() {
            const base = moment().local();
            const start = base.clone().startOf('isoWeek').startOf('day');
            const end = base.clone().startOf('isoWeek').add(6, 'days').endOf('day');

            this.searchRequest.startSearchDate = start.toDate();
            this.searchRequest.endSearchDate   = end.toDate();

            console.log("START ::: ",this.searchRequest.startSearchDate);
        },
        toYYYYMMDD(date) {
            if (!(date instanceof Date)) return ''
            const y = date.getFullYear()
            const m = String(date.getMonth() + 1).padStart(2, '0')
            const d = String(date.getDate()).padStart(2, '0')
            return `${y}${m}${d}`
        }, 
        getDepartmentOptions() {
            // Departments
            const self = this;

            const url = self.$api('uri', 'get-department');
            const json_query = JSON.stringify({
                showRootNode: true,
                menuAccessLevelCode: "FLEXBEN_ACCESS_LEVEL",
            });
            self.$axios.get(url, { params: { json_query } }).then((res) => {
                const options = res.data.data.list.map((dep) => ({
                    text: dep.departmentName,
                    value: dep.departmentSeq,
                }));

                self.departmentOptions.push(...options);
            });
        },
        getJobTitleOptions() {
            // Tiers
            const self = this;

            const json_query = JSON.stringify({
                limit: -1,
                offset: 0,
            });
            const url = self.$api('uri', 'get-jobTitle');
            self.$axios.get(url, { params: { json_query } }).then((res) => {
                const options = res.data.data.list.map((title) => ({ text: title.jobTitleName, value: title.jobTitleSeq }));
                self.jobTitleOptions.push(...options);
            });
        },
        getEmployeeOptions() {
            const self = this;
            let url = self.$api('uri', 'get-employee-include-status-resigned')
            const json_query = JSON.stringify({
                limit: -1,
                offset: 0,
            });

            self.$axios
                .get(url, { params: { json_query } })
                .then((res) => {
                   // self.employeeOptions = res.data.data.list.map((emp) => ({ text: emp.employeeName, value: emp.employeeSeq }));
                    const allowedStatus = self.employeeSearchForm.employeeStatusList;

                    self.employeeOptions = res.data.data.list
                        // 상태 필터
                        .filter(emp => allowedStatus.includes(emp.employeeStatus))
                        // 자동완성용 변환
                        .map((emp) => ({
                            text: emp.employeeName,
                            value: emp.employeeSeq,
                        }));
                    })
                .catch((err) => {
                    console.error('err : ', err);
                });
        },
        fitDecimalFormatWithComma : NumberFormatUtil.fitDecimalFormatWithComma,
        lockBodyScroll() {
            // 현재 스크롤 위치 저장
            this.scrollYBackup = window.scrollY || document.documentElement.scrollTop || 0;

            // 레이아웃 점프 방지 및 스크롤 잠금
            document.body.style.position = 'fixed';
            document.body.style.top = `-${this.scrollYBackup}px`;
            document.body.style.left = '0';
            document.body.style.right = '0';
            document.body.style.width = '100%';
            document.body.style.overflow = 'hidden'; // 보조(데스크톱)
        },
        unlockBodyScroll() {
            // 원복
            const y = this.scrollYBackup || 0;
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.left = '';
            document.body.style.right = '';
            document.body.style.width = '';
            document.body.style.overflow = '';

            // 저장해 둔 위치로 복귀
            window.scrollTo(0, y);
        },
        searchSelectedDate() {
            const self = this;
         
            self.getPointUsageHistory();
        },
        getPointUsageHistory(offset=0 ){

            const self =  this;
            self.searchRequest.offset= offset;
            self.searchRequest.employeeSeqList = [ self.selectedOneEmployee.employeeSeq ];

            const payload = {
                ...this.searchRequest,
                offset,
                startSearchDate: this.searchRequest.startSearchDate
                ? this.toYYYYMMDD(this.searchRequest.startSearchDate)
                : '',
                endSearchDate: this.searchRequest.endSearchDate
                ? this.toYYYYMMDD(this.searchRequest.endSearchDate)
                : '',
            }

            // only for aboitiz - cost center, business unit
            if (self.isAboitiz && offset === 0) {
                const { schType = '', schKeyword = '' } = self.selectSearchedValues || {};
                self.searchRequest.schType = schType;
                self.searchRequest.schKeyword = schKeyword;
            }

            const json_query = JSON.stringify(payload);
            const url = self.$api("uri", "get-flexben-point-usage-list");
            self.$axios
            .get(url, { params: { json_query } })
            .then( res =>{
                self.histListEmployee = res.data.data.list;
                self.totalCount = res.data.data.total;
                self.walletCategoryCnt = res.data.data.walletCategoryCnt;
            })
            .catch(err =>{
                console.error( "err : " , err);
            })
        },
        downLoadUsageHistory(list){
            const self = this;
            const json_query = {
                employeeSeqList: list,
                startSearchDate: this.toYYYYMMDD(this.searchRequest.startSearchDate),
                endSearchDate: this.toYYYYMMDD(this.searchRequest.endSearchDate),
            };
            
            const url = self.$api("uri", "post-flexben-point-usage-excel-download");
            self.$axios
            .post(url, json_query )
            .then((res) => {
                const downloadLink = res.data.data.excelFilePath;
                {
                    const aElem = document.createElement('a');
                    aElem.href = downloadLink;
                    aElem.click();
                }
                self.openSelectDownOption = false;
            })
            .catch((err) => {
                console.error(err);
                alert(" failed to download excel.")
            });
            
        },
        getFlexbenEmployee(){
            const self = this;
            const {jobTitleSeq, departmentSeq, employeeStatusList} = self.employeeSearchForm;
            let employeeSeqList;
            if( ! self.employeeNameForSearch ){
                employeeSeqList = null;    
            }else{
                employeeSeqList = self.employeeOptions
                                    .filter(({text}) => text?.toLowerCase().includes(self.employeeNameForSearch.toLowerCase()))
                                    .map(({value}) => value);
            }
            const searchForm = {
                jobTitleSeq,
                departmentSeq,
                employeeStatusList,
                employeeSeqList,
            }
            if (self.isAboitiz) {
                const { schType = '', schKeyword = '' } = self.selectSearchedValues || {};
                if (schType || schKeyword) {
                    searchForm.schType = schType;
                    searchForm.schKeyword = schKeyword;
                }
            }
            const json_query = JSON.stringify(searchForm);
            const url = self.$api('uri', 'get-flexben-point-usage-employee-list');
            return self.$axios.get(url,  { params: { json_query } })
        },
        async searchFlexbenEmployee(){
            const self = this;
            try{
                const empRes = await self.getFlexbenEmployee();
                self.searchedEmployeeListAll = self.orderByKeyAsc("employeeName", empRes.data.data.list);
                self.displayEmployeeList = self.loadEmployeeMore(0);
                self.clickEmployee(self.displayEmployeeList[0]);
            }catch (error) {
                console.error('Error:', error);
            }
        },
        loadEmployeeMore( currentCount ){
            const self = this;
            //최초에 검색용으로 모든 employee 를 가지고 오므로 따로 20개씩 로드 하지 않고 가지고 있는 데이터 잘라서 사용용
            const nextCount = currentCount + self.employeeLoadCount;
            return self.searchedEmployeeListAll.slice(0, nextCount);
        },
        clickEmployee(empl){
            const self = this;
            if(! empl ){
                self.selectedOneEmployee = {};
                self.histListEmployee = [];
                self.totalCount = 0;
                return;
            }
            self.selectedOneEmployee = empl;
            self.getPointUsageHistory();
        },
        afterClickPage(offset){
            const self = this;
            self.getPointUsageHistory(offset);
        },
        dateFormatter(dateStr, outputFormat = 'MM/DD/YYYY') {
            if (!dateStr) return '';
            return moment(dateStr).format(outputFormat);
        },
        showDetailPopup(detail){
            const self = this;
            self.showDetailPopupOpen = true;
            self.goodsOrder = { ...detail };
        },
        orderByKeyAsc(key, list) {
            return list.sort((a, b) => {
                const valA = a[key];
                const valB = b[key];

                return valA.toLowerCase().localeCompare(valB.toLowerCase());
            });
        },
    }
}
</script>
